module.exports = __webpack_public_path__ + "img/mini-024.d9d5590a.jpg";